exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1ihS88DbWHKcNZT3Dr2Tn_{\n    border-radius: 3px;\n    color: white;\n    display: inline-block;\n}\n\n._1ihS88DbWHKcNZT3Dr2Tn_ *{\n    cursor: pointer;\n}\n\n._1ihS88DbWHKcNZT3Dr2Tn_ > * > * {\n    background-color: #2968A5;\n}\n\n._1ihS88DbWHKcNZT3Dr2Tn_ > * > *:hover{\n    background-color: #255187;\n}\n\n._36JJu30PwGOQFcAoa4JNam > *{\n    border-top-left-radius: 3px;\n    border-bottom-left-radius: 3px;\n}\n\n._3-R8tn7zxhfrtqGOIYzQ6w > *{\n    border-top-right-radius: 3px;\n    border-bottom-right-radius: 3px;\n}", ""]);

// exports
exports.locals = {
	"toolbar": "_1ihS88DbWHKcNZT3Dr2Tn_",
	"first": "_36JJu30PwGOQFcAoa4JNam",
	"last": "_3-R8tn7zxhfrtqGOIYzQ6w"
};